import actions from './actions';
import mutations from './mutations';

// state initial values
const state = {
  projectId: 0,
  shippingTotal: 0,
  taxTotal: 0,
  clientSecret: '',
  paymentIntentId: ''
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
